import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import { Marker } from "@react-google-maps/api";

import styles from "./styles/SearchPage.module.css";
import Cards from "../../Components/Card/Card";
import cardBg from "../../Assets/card-img.jpg";
import { toast } from "react-toastify";
import Loading from "../../Components/Loading/Loading";
function SearchPage() {
  const { lat, lng } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [data, updateData] = useState([]);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "YOUR_API_KEY",
  });

  const [map, setMap] = React.useState(null);

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds({
      lat: +lat,
      lng: +lng,
    });
    map.fitBounds(bounds);
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  console.log(+lat, +lng);

  useEffect(() => {
    setIsLoading(true);

    axios
      .post("/assetList", {
        filterType: "RADIUS",
        latitude: +lat, // Get From Google  API
        longitude: +lng, // Get From Google  API
        // latitude: "-74.16762811584077", // Get From Google  API
        // longitude: "40.349159350420635", // Get From Google  API
        radius: 1, // hardcode for now - This should be passed when we zoomin /out of map
      })
      .then((res) => {
        updateData(res.data.assetList);
        console.log(res.data.assetList);
      })
      .catch((err) => {
        console.log(err);

        toast.error("Uh Oh! Something went wrong while fetching data");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  return (
    <div className={styles.searchPage}>
      {isLoading && <Loading />}
      <div className={styles.leftSearch}>
        {isLoaded ? (
          <GoogleMap
            mapContainerStyle={{
              width: "100%",
              height: "100%",
            }}
            center={{ lat: +lat, lng: +lng }}
            zoom={10}
            onLoad={onLoad}
            onUnmount={onUnmount}
          >
            {/* Child components, such as markers, info windows, etc. */}
            <>
              <Marker position={{ lat: +lat, lng: +lng }} />
              {data.map((el, idx) => {
                return (
                  <Marker
                    position={{
                      lat: el.latitude,
                      lng: el.longitude,
                    }}
                  />
                );
              })}
            </>
          </GoogleMap>
        ) : (
          <></>
        )}
      </div>
      <div className={styles.rightSearch}>
        {data.map((elem, idx) => {
          return <Cards {...elem} key={idx + Date() + "Searched"} />;
        })}
      </div>
    </div>
  );
}

export default SearchPage;
